// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SI7IS{padding:24px;text-align:start}.yjvYv{display:flex;align-items:flex-start}.FpAVd{display:flex;align-items:flex-end;align-self:flex-start;height:24px;margin-left:-4px;padding-right:4px}.FNut1{flex:1;inline-size:300px;max-inline-size:90%}.FNut1.A5Ohn{max-inline-size:80%}.CzAgW{border-radius:4px;padding:0px 4px 0px 4px;margin:-4px;border:1px solid transparent;transition:background-color .2s ease,border-color .2s ease}.CzAgW.nqHBF{cursor:pointer;max-width:100%;width:fit-content}.CzAgW.nqHBF:hover{border-color:#d4d4e0}.CzAgW.nqHBF:hover .KNeYS{color:#282863}.CzAgW.nqHBF:hover .tVDvL [class*="secondarySkin"]{color:#282863 !important}.yhcUq{gap:8px}.KNeYS{display:inline-flex;align-items:center;background:none;border:none;padding:0;cursor:pointer;color:#696992;transition:color .2s ease,text-decoration .2s ease;flex-shrink:0}.KNeYS svg{display:block}.vtKeU{padding-top:16px;padding-bottom:16px;display:flex;align-items:center;gap:12px;flex-wrap:wrap}.oegXG{display:flex;gap:8px;align-items:center;margin-left:auto}.y7WK6{margin-block-start:20px;padding-block-start:5px}.y7WK6.Yyohj{border-top:0;padding-top:0}.y7WK6:empty{display:none}.q_g_u{margin-bottom:16px}.fV3Hg{margin-top:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"serviceDetails": `SI7IS`,
	"descriptionAndMenuButtonContainer": `yjvYv`,
	"dragHandleSlot": `FpAVd`,
	"detailedDescription": `FNut1`,
	"withBadge": `A5Ohn`,
	"serviceNameAndDescriptionContainer": `CzAgW`,
	"clickable": `nqHBF`,
	"editIconButton": `KNeYS`,
	"serviceDescriptionContainer": `tVDvL`,
	"serviceNameRow": `yhcUq`,
	"finalPriceContainer": `vtKeU`,
	"badgeAndDotMenuContainer": `oegXG`,
	"additionalSection": `y7WK6`,
	"disableBorder": `Yyohj`,
	"includedServicesContainer": `q_g_u`,
	"section": `fV3Hg`
};
export default ___CSS_LOADER_EXPORT___;
